import React from 'react'

import type { IconTypes } from './Icon.helpers';
import { Icons } from './Icon.helpers'

export type IconProps = {
  name: IconTypes
}

const Icon = ({ name }: IconProps) => {
  const SelectedIcon = Icons[name]
  return <SelectedIcon />
}

export default Icon
